import axios from 'axios';

const NoozApi = axios.create({
  baseURL: process.env.GATSBY_NOOZ_API_URL,
  headers: {
    zone: process.env.GATSBY_ZONE,
    'contentful-env': process.env.GATSBY_CONTENTFULL_ENVIRONMENT,
  },
});

export const setToken = (token) => {
  NoozApi.defaults.headers.common['x-shopify-access-token'] =
    token || undefined;
};
export const setLocale = () => {
  try {
    let locale: string | string[] = window.location.pathname
      .split('/')
      [process.env.NODE_ENV === 'development' ? 1 : 2].split('-');
    locale[1] = locale[1].toUpperCase();
    locale = locale.join('-');
    locale = locale.includes('GB') || locale.includes('EU') ? 'en' : locale;

    NoozApi.defaults.headers.common.locale = locale;
  } catch (e) {}
};

export default NoozApi;
